import React, { useState, useEffect, useContext } from "react";
import "./Define.css";
import {
	Grid,
	Box,
	Chip,
	TextField,
	Typography,
	MenuItem,
	Button,
	Checkbox,
	FormControlLabel,
	Divider,
	Backdrop,
	CircularProgress,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Paper,
	Stack,
	Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch, useStore } from "react-redux";
import DefineQuotaChart from "./DefineQuotaChart";
import DefineQuotaBreakdown from "./DefineQuotaBreakdown";
import SharedComponent from "./SharedComponent";
import ExportData from "./ExportData";
import {
	SaveOutlined,
	DrawRounded,
	TaskAltOutlined,
	DownloadOutlined,
	UploadOutlined,
	Close,
	UploadFile,
	TaskAltRounded,
	SpeakerNotesOutlined,
	DoNotDisturbOutlined,
} from "@mui/icons-material";
import Dropzone from "react-dropzone";
import Draggable from "react-draggable";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Comments from "./comments";
import FileAttach from "./FileAttach";
import Attachments from "./Attachments";
import CollapseSection from "../../components/ui/CollapseSection";
import {
	GetUserCountries,
	GetScenarioforQuotaDefinition,
	GetQuotaPeriods,
	GetQuotaDetails,
	GetQuotaChartData,
	setSelectedCountry,
	setSelectedScenario,
	setSelectedPeriod,
	setForecast,
	setQuotaCopy,
	setTimeDepletion,
	setDepletionPeriodType,
	GetDepletionModels,
	GetDepletionPeriodTypes,
	GetRounderTypes,
	setSelectProduct,
	setRounder,
	setSelectedRounderTypeID,
	setApplyRounder,
	setApplyOverBoxRounder,
	setSafetyMargin,
	setBufferAdjustment,
	setApplySafetyMargin,
	GetSKUOrPGByScenario,
	setTotalValues,
	setWeekPercent,
	setWeekPercentDepletion,
	GetWeeklyDepletionValues,
	setLoadData,
	reset,
	ExportExcel,
	ImportExcel,
	setQuotaObject,
	SaveQuota,
	Upload,
	SubmitQuota,
	DownloadFile,
	setState,
	setApplyBufferAdjustment,
} from "./defineSlice";
import ViewSearchRefresh from "./ViewSearchRefresh";
import DefineQuotaTable from "./DefineQuotaTable";
import ChartTableToggle from "./ChartTableToggle";
import {
	formatNumber,
	removeComma,
	isOverBoxRounderTypeSelected,
	isDigitsOnlyNumericInput,
	hasNaNOverBoxRoundValues,
} from "./defineUtils";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteExistingFile } from "./defineSlice";
import ExportDataModal from "./ExportDataModal";
import OverBoxRounderDialog from "./OverBoxRounderDialog";

function PaperComponent(props) {
	return (
		<Draggable
			handle="#draggable-dialog-title"
			cancel={'[class*="MuiDialogContent-root"]'}
		>
			<Paper {...props} />
		</Draggable>
	);
}

const criticalities = [
	{ key: 0, value: "None" },
	{ key: 1, value: "Low" },
	{ key: 2, value: "Medium" },
	{ key: 3, value: "High" },
	{ key: 4, value: "Severe" },
	{ key: 5, value: "Other" },
];

function DefineQuota() {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const store = useStore();
	const define = useSelector((state) => state.define);
	const {
		isLoading,
		countries,
		selectedCountry,
		scenarioList,
		selectedScenario,
		quotaPeriods,
		depletionModelsList,
		depletionPeriodTypesList,
		rounderTypesList,
		selectedDepletionPeriodType,
		selectedPeriod,
		selectedQuota,
		loadQuotaDetails,
		loadQuotaChart,
		selectedDepletion,
		listProduct,
		selectedProduct,
		TotalAdjustment,
		TotalSafetyMargin,
		TotalUnusedQuota,
		TotalQuota,
    TotalTender,
		rounder,
		selectedRounderTypeID,
		overBoxRoundValues,
		initialForecast,
		revisedQuota,
		onSubmitDisabled,
		forecastType,
		commonSafetyMargin,
		bufferAdjustment,
		quotaCopy,
		isNavigate,
		filter_customerTypes,
		filter_customerTrustLevels,
		gridData,
		persistDepletionTypeOnAllocate,
		filter_skuName,
		searchText,
		ForecastAdjustment
	} = define;

	const [open, setOpen] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState(undefined);
	const [currentFile, setCurrentFile] = useState(undefined);
	const [overBoxDialogOpen, setOverBoxDialogOpen] = useState(false);

	useEffect(() => {
		if (!isNavigate) {
			dispatch(reset("onRefresh"));
			dispatch(GetUserCountries({ method: "Get" }));
		} else {
			dispatch(reset("onRefresh"));
			dispatch(setState("isNavigate", false));
		}
	}, []);

	const handleCountryChange = (e) => {
		let v = e.target.value;
		dispatch(setState("selectedRows", []));
		dispatch(setSelectedCountry(v));
		dispatch(reset("countryChange"));
		dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: v }));
		// dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: id })).then(() => {
		//     dispatch(GetQuotaPeriods({ method: "GET"}));
		// });
	};

	const handleScenarioChange = (e) => {
		let v = e.target.value;
		//dispatch(setState("selectedRows", []));
		dispatch(setSelectedScenario(v));
		//dispatch(reset("scenarioChange"));
		//dispatch(GetQuotaPeriods({ method: "GET", scenarioID: v }));
	};

	useEffect(() => {
		if (selectedScenario.scenarioID) {
			dispatch(setState("selectedRows", []));
			dispatch(reset("scenarioChange"));
			dispatch(
				setState(
					"hideWeekColumns",
					selectedScenario.periodType === "Monthly" ? true : false
				)
			);
			dispatch(
				GetQuotaPeriods({
					method: "GET",
					scenarioID: selectedScenario.scenarioID,
				})
			);
			dispatch(GetDepletionModels({ method: "GET" }));
			dispatch(GetDepletionPeriodTypes({ method: "GET" }));
			dispatch(GetRounderTypes({ method: "GET" }));
		}
	}, [selectedScenario]);

	useEffect(() => {
		const sid = selectedScenario?.scenarioID;
		const psd = selectedPeriod?.startDate;
		const dptId =
			selectedDepletionPeriodType?.depletionPeriodTypeID;
		if (
			!sid ||
			!psd ||
			dptId === undefined ||
			dptId === null ||
			dptId === ""
		) {
			return;
		}
		dispatch(GetWeeklyDepletionValues({ method: "GET" }));
	}, [
		selectedDepletionPeriodType?.depletionPeriodTypeID,
		dispatch,
	]);

	const handlePeriodChange = (e) => {
		dispatch(reset("onPeriodChange"));
		let v = e.target.value;
		dispatch(setState("selectedRows", []));
		dispatch(setSelectedPeriod(v));
		//dispatch(GetDepletionModels({ method: "GET" }));
		//dispatch(GetDepletionPeriodTypes({ method: "GET" }));
	};

	const handleDepletionPeriodTypeChange = (e) => {
		const value = e.target.value;
		if (value == null || value === "") return;
		dispatch(setDepletionPeriodType(value));
	};

	const handleRetrive = () => {
		caches.keys().then(names=>names.forEach(n => caches.delete(n)));
		dispatch(setState("gridDataChanged", false));
		if (
			selectedCountry.countryID === undefined ||
			selectedCountry.countryID === null
		) {
			showMessage("Please select a country", "info");
		} else if (
			selectedScenario.scenarioID === undefined ||
			selectedScenario.scenarioID === null
		) {
			showMessage("Please select a scenario", "info");
		} else if (
			selectedPeriod.startDate === undefined ||
			selectedPeriod.startDate === null
		) {
			showMessage("Please select a validity period", "info");
		} else {
			dispatch(setState("filter_customerTypes", []));
			dispatch(setState("filter_customerTrustLevels", []));
			dispatch(setState("filter_skuName", []));
			dispatch(setState("filter_skuNumber", []));
			dispatch(setState("selectedRows", []));

			dispatch(reset("onRetriveClick"));
			let queryParams =
				"scenarioId=" +
				selectedScenario.scenarioID +
				"&startDate=" +
				selectedPeriod.startDate +
				"&endDate=" +
				selectedPeriod.endDate +
				"&countryId=" +
				selectedCountry.countryID +
				"&breakdown=" +
				false;
				dispatch(setSelectedScenario(selectedScenario.scenarioID));
			dispatch(
				GetQuotaDetails({ method: "GET", queryParams: queryParams })
			).then((response) => {
				dispatch(setTotalValues());
				dispatch(GetSKUOrPGByScenario({ method: "GET" })).then(() => {
					const dptId =
						selectedDepletionPeriodType?.depletionPeriodTypeID;
					const afterWeekly = () => {
						dispatch(setTotalValues());
						dispatch(setLoadData());
						dispatch(GetQuotaChartData({ method: "POST" }));
					};
					if (
						dptId !== undefined &&
						dptId !== null &&
						dptId !== ""
					) {
						dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(
							afterWeekly
						);
					} else {
						dispatch(setWeekPercent());
						afterWeekly();
					}
				});
			});
		}
	};
	const showMessage = (message, severity) => {
		dispatch(setState("isFailed_Info", message));
		dispatch(setState("isFailed", true));
	};
	const onSubmit = (values) => {};

	const handleForecastType = () => {};

	const handleQuotaCopy = (e) => {
		let v = e.target.value;
		v = removeComma(v);
		dispatch(setQuotaCopy(v));
	};

	const handleForecast = (e) => {
		let v = e.target.value;
		v = removeComma(v);
		dispatch(setForecast(v));
	};

	const handleTimeDepletion = (e) => {
		let v = e.target.value;
		dispatch(setTimeDepletion(v));
		// Reducer runs synchronously; closure `gridData` is still stale — use fresh store slice.
		handleAllocate(store.getState().define.gridData);
	};
	const handleAllocate = (gridSnapshot) => {
		// Button passes click event as first arg — only trust real grid arrays.
		const gridForSnapshot = Array.isArray(gridSnapshot) ? gridSnapshot : gridData;
		dispatch(
			setState(
				"allocateCustomerBreakdownSnapshot",
				gridForSnapshot?.length
					? gridForSnapshot.map((r) => ({ ...r }))
					: null
			)
		);
		dispatch(setState("gridDataChanged", true));
		dispatch(reset("onAllocateClick"));
		let queryParams =
			"scenarioId=" +
			selectedScenario.scenarioID +
			"&startDate=" +
			selectedPeriod.startDate +
			"&endDate=" +
			selectedPeriod.endDate +
			"&countryId=" +
			selectedCountry.countryID +
			"&breakdown=" +
			true;
		dispatch(GetQuotaDetails({ method: "GET", queryParams: queryParams })).then(
			() => {
				const dptId =
					selectedDepletionPeriodType?.depletionPeriodTypeID;
				const chain = () => {
					dispatch(setWeekPercentDepletion());
					dispatch(setLoadData());
					dispatch(GetQuotaChartData({ method: "POST" }));
				};
				if (
					dptId !== undefined &&
					dptId !== null &&
					dptId !== ""
				) {
					dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(chain);
				} else {
					chain();
				}
			}
		);
	};

	const handleSelectProduct = (e) => {
		dispatch(setState("selectedRows",[]));
		let v = e.target.value;
		dispatch(reset("onProductChange"));
		dispatch(setSelectProduct(v));
		dispatch(setLoadData());
		dispatch(GetQuotaChartData({ method: "POST" }));
		let val = gridData?.filter((item) => {
			return (
				(filter_customerTypes.length === 0 ||
					filter_customerTypes.some((type) =>
						item.type.toLowerCase().includes(type.toLowerCase())
					)) &&
				(filter_customerTrustLevels.length === 0 ||
					filter_customerTrustLevels.some((level) =>
						item.customerTrustLevel.toLowerCase().includes(level.toLowerCase())
					)) &&
				(filter_skuName.length === 0 ||
					filter_skuName.some((sku) =>
						item.skuName.toLowerCase().includes(sku.toLowerCase())
					)) &&
				(v === 0 || v === undefined || item.skuid === v) &&
				(item.skuName?.toLowerCase().includes(searchText) ||
					item.skuNumb?.toLowerCase().includes(searchText) ||
					item.customerName?.toLowerCase().includes(searchText) ||
					item.customerGroupName?.toLowerCase().includes(searchText) ||
					item.customerNumber?.toLowerCase().includes(searchText))
			);
		});
		dispatch(setState("gridDataFiltered", val));
		// dispatch(GetQuotaChartData({ method: "POST" }));
	};

	const handleRounder = (e) => {
		let v = removeComma(e.target.value);
		if (!isDigitsOnlyNumericInput(v)) {
			dispatch(setState("isError", true));
			dispatch(setState("isError_Info", "Only numbers are allowed."));
			return;
		}
		dispatch(setRounder(v));
	};
	const handleSafetyMargin = (e) => {
		let v = e.target.value;
		v = removeComma(v);
		if (v === "0-") {
			v = "-";
		}
		dispatch(setSafetyMargin(v));
	};
	const handleBufferAdjustment = (e) => {
		let v = e.target.value;
		v = removeComma(v);
		if (v === "0-") {
			v = "-";
		}
		dispatch(setBufferAdjustment(v));
	};

	const applyRounder = () => {
		const currentRounder = store.getState().define.rounder;
		if (Number.isNaN(currentRounder)) {
			dispatch(setState("isError", true));
			dispatch(setState("isError_Info", "Only numbers are allowed."));
			return;
		}
		dispatch(setState("gridDataChanged", true));
		dispatch(setState("isLoading", true));
		let timeout = setTimeout(() => {
			dispatch(reset("onApplyRounder"));
			//dispatch(setApplySafetyMargin());
			//dispatch(setApplyBufferAdjustment());
			dispatch(setApplyRounder());
			dispatch(setTotalValues());
			dispatch(setLoadData());
			dispatch(GetQuotaChartData({ method: "POST" }));
		}, 10);
		return () => clearTimeout(timeout);
	};

	const applyOverBoxRounder = () => {
		const { overBoxRoundValues } = store.getState().define;
		if (hasNaNOverBoxRoundValues(overBoxRoundValues)) {
			dispatch(setState("isError", true));
			dispatch(setState("isError_Info", "Only numbers are allowed."));
			return;
		}
		dispatch(setState("gridDataChanged", true));
		dispatch(setState("isLoading", true));
		let timeout = setTimeout(() => {
			dispatch(reset("onApplyRounder"));
			dispatch(setApplyOverBoxRounder());
			dispatch(setTotalValues());
			dispatch(setLoadData());
			dispatch(GetQuotaChartData({ method: "POST" }));
			setOverBoxDialogOpen(false);
		}, 10);
		return () => clearTimeout(timeout);
	};

	const applySafetyMargin = () => {
		dispatch(setState("gridDataChanged", true));
		dispatch(setState("isLoading", true));
		let timeout = setTimeout(() => {
			dispatch(reset("onApplyRounder"));
			dispatch(setApplySafetyMargin());
			dispatch(setTotalValues());
			dispatch(setLoadData());
			dispatch(GetQuotaChartData({ method: "POST" }));
		}, 10);
		return () => clearTimeout(timeout);
	};

	const applyBufferAdjustment = () => {
		dispatch(setState("gridDataChanged", true));
		dispatch(setState("isLoading", true));
		let timeout = setTimeout(() => {
			dispatch(reset("onApplyRounder"));
			dispatch(setApplyBufferAdjustment());
			dispatch(setTotalValues());
			dispatch(setLoadData());
			dispatch(GetQuotaChartData({ method: "POST" }));
		}, 10);
		return () => clearTimeout(timeout);
	};
	const handleDownloadQuota = () => {
		dispatch(setQuotaObject({ method: "excelDownload" }));
		dispatch(ExportExcel({ method: "POST" }));
	};

	const handleUploadQuota = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setSelectedFiles("");
		setOpen(false);
	};

	const onDrop = (files) => {
		console.log("onDrop files", files);
		if (files.length > 0) {
			setSelectedFiles(files);
		}
	};

	const handleProcess = () => {
		dispatch(setState("gridDataChanged", true));
		dispatch(reset("onImportExcel"));
		let currentFile = selectedFiles[0];
		setCurrentFile(currentFile);
		setSelectedFiles("");
		let formData = new FormData();
		formData.append("files", currentFile);
		dispatch(ImportExcel({ method: "POST", body: formData })).then(() => {
			dispatch(setTotalValues());
			dispatch(setLoadData());
			dispatch(GetQuotaChartData({ method: "POST" }));
		});
		setOpen(false);
	};

	const handleSaveQuota = () => {
		dispatch(setState("gridDataChanged", false));
		dispatch(Upload({ method: "POST" })).then(() => {
			dispatch(setQuotaObject({ method: "saveQuota" }));
			dispatch(SaveQuota({ method: "POST" })).then((response) => {
				if (response.payload !== "error") {
					dispatch(reset("onAllocateClick"));
					dispatch(setLoadData());
					dispatch(GetQuotaChartData({ method: "POST" }));
				}
			});
			dispatch(setState("saveOrSubmitError", 0));
		});
	};

	const handleSubmitQuota = () => {
		dispatch(setState("gridDataChanged", false));
		dispatch(Upload({ method: "POST" })).then(() => {
			dispatch(setQuotaObject({ method: "submitQuota" }));
			dispatch(SubmitQuota({ method: "POST" })).then((response) => {
				if(typeof response.payload === "object"  && response.payload !== null && 'quotaID' in response.payload)//Success
				{
					dispatch(reset("onsubmitQuota"));
					dispatch(setLoadData());
					dispatch(GetQuotaChartData({ method: "POST" }));
				}
				else{
					handleRetrive();
				}

				// if (response.payload !== "error") {
				// 	handleRetrive();
				// }
			});
			dispatch(setState("saveOrSubmitError", 0));
		});
	};

	const handleDownloadFile = (filepath) => {
		dispatch(DownloadFile(filepath));
	};

	function handleDeleteFile(file) {
		console.log(file);
		dispatch(deleteExistingFile(file));
	}

	return (
		<Box>
			<Typography variant="subtitle1" my={2}>
				Search for Scenario
			</Typography>
			{/* <form onSubmit={handleSubmit(onSubmit)}> */}
			{/* <Box className="scenario-search"> */}
			<Grid
				container
				columns={12}
				justifyContent="flex-start"
				alignItems="center"
				spacing={3}
				pb={1}
				sx={{ mb: 2 }}
			>
				<Grid item xs={12} sm={6} md={2.9} lg={2.9}>
					<TextField
						variant="outlined"
						label="Country"
						select={countries.length > 0 ? true : false}
						value={countries.length > 0 ? selectedCountry.countryID : " "}
						onChange={handleCountryChange}
						fullWidth
						size="small"
						// disabled={countries.length > 0 ? false : true}
						// {...register("country", {
						//     required: "Please select a country",
						// })}
						// error={Boolean(errors.country)}
						// helperText={errors ?.country ?.message}
					>
						{countries.length > 0
							? countries.map((country, index) => {
									return (
										<MenuItem key={country.countryID} value={country.countryID}>
											{country.countryName}
										</MenuItem>
									);
							  })
							: null}
					</TextField>
				</Grid>
				<Grid item xs={12} sm={6} md={4} lg={4}>
					<TextField
						variant="outlined"
						label="Scenario"
						select={scenarioList.length > 0 ? true : false}
						value={scenarioList.length > 0 ? selectedScenario.scenarioID : ""}
						onChange={handleScenarioChange}
						size="small"
						fullWidth
						disabled={scenarioList.length > 0 ? false : true}
						// required
						// {...register("scenario", {
						//     required: "Please select a scenario",
						// })}
						// error={Boolean(errors.scenario)}
						// helperText={errors ?.scenario ?.message}
					>
						{scenarioList.length > 0
							? scenarioList.map((scenario, index) => {
									return (
										<MenuItem
											key={scenario.scenarioID}
											value={scenario.scenarioID}
										>
											{scenario.scenarioName}
										</MenuItem>
									);
							  })
							: null}
					</TextField>
				</Grid>
				<Grid item xs={12} sm={6} md={3} lg={4}>
					<TextField
						variant="outlined"
						label="Validity Period"
						select={quotaPeriods.length > 0 ? true : false}
						value={quotaPeriods.length > 0 ? selectedPeriod.displayDate : ""}
						onChange={handlePeriodChange}
						size="small"
						fullWidth
						disabled={quotaPeriods.length > 0 ? false : true}
						// {...register("currentPeriod", {
						//     required: "Please select validity period.",
						// })}
						// error={Boolean(errors.currentPeriod)}
						// helperText={errors ?.currentPeriod ?.message}
					>
						{quotaPeriods.length > 0
							? quotaPeriods.map((quota, index) => {
									return (
										<MenuItem key={quota.displayDate} value={quota.displayDate}>
											{quota.displayDate}
										</MenuItem>
									);
							  })
							: null}
					</TextField>
				</Grid>
				<Grid item xs={12} sm={6} md={2} lg={1}>
					<Box justifyContent="center" display="flex">
						<Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								fontWeight: "700",
								textTransform: "none",
								"&:hover": {
									bgcolor: "darkred.main",
								},
							}}
							startIcon={<SearchIcon />}
							variant="contained"
							onClick={handleRetrive}
							size="large"
						>
							Retrieve
						</Button>
					</Box>
				</Grid>
			</Grid>
			{loadQuotaDetails && (
				<>
					<CollapseSection sx={{ mt: 2 }} title="Define Quota">
						<Grid
							container
							columns={12}
							justifyContent="space-between"
							alignItems="center"
							spacing={2}
							sx={{ paddingTop: "10px", paddingLeft: "10px" }}
						>
							<Grid item xs={12} sm={6} md={8} lg={9}>
								<Box
									sx={{
										display: "flex",
										justifyContent: "align-start",
										alignItems: "center",
									}}
								>
									<Typography
										variant="subtitle1"
										sx={{ display: "inline", mr: 2 }}
									>
										{`${selectedScenario?.scenarioName}`}
										{"  "}
									</Typography>
									<Typography
										variant="p14w500"
										sx={{
											backgroundColor: "#efefef",
											p: 1,
											py: 1,
											pl: 1,
											borderRadius: "30px 30px 30px 30px",
										}}
									>
										{`Criticality: `}
										<b>
											{
												criticalities.find(
													(item) => item.key === selectedScenario.criticalityId
												).value
											}
										</b>
									</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sm={3} md={2} lg={2}>
								<Typography variant="subtitle1">
									Quota status
									<Chip
										icon={
											(selectedQuota?.quotaStatus === "Approved" && (
												<TaskAltRounded />
											)) ||
											(selectedQuota?.quotaStatus === "Locally Approved" && (
												<TaskAltRounded />
											)) ||
											(selectedQuota?.quotaStatus === "Draft" && (
												<DrawRounded />
											)) ||
											(selectedQuota?.quotaStatus === "Submitted" && (
												<DrawRounded />
											)) ||
											(selectedQuota?.quotaStatus === "Rejected" && (
												<DrawRounded />
											)) ||
											(selectedQuota?.quotaStatus === "Invalid" && (
												<DrawRounded />
											)) ||
											((selectedQuota?.quotaStatus === null ||
												selectedQuota?.quotaStatus === " ") && (
												<DoNotDisturbOutlined />
											))
										}
										label={
											selectedQuota?.quotaStatus === null ||
											selectedQuota?.quotaStatus === " "
												? "N/A"
												: selectedQuota?.quotaStatus
										}
										color={
											(selectedQuota?.quotaStatus === "Approved" &&
												"success") ||
											(selectedQuota?.quotaStatus === "Locally Approved" &&
												"success") ||
											(selectedQuota?.quotaStatus === "Draft" && "info") ||
											(selectedQuota?.quotaStatus === "Submitted" && "info") ||
											(selectedQuota?.quotaStatus === "Rejected" && "error") ||
											(selectedQuota?.quotaStatus === "Invalid" && "error") ||
											((selectedQuota?.quotaStatus === null ||
												selectedQuota?.quotaStatus === " ") &&
												"error")
										}
										variant="outlined"
										size="small"
										sx={{ ml: 1, p: 1 }}
									/>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3} md={2} lg={1}>
								<ExportData />
							</Grid>
						</Grid>

						<ExportDataModal />

						<Divider sx={{ margin: "16px 0" }} />
						<Grid
							container
							columns={12}
							justifyContent="space-between"
							alignItems="center"
							spacing={2}
							pb={1}
						>
							<Grid item xs={12} sm={12} md={2.5} lg={2.5} sx={{ mt: 2 }}>
							<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<TextField
										disabled={true}
										variant="outlined"
										label="Forecast"
										InputProps={{
											readOnly: true,
											style: {
											  fontStyle: 'italic',
											},
										  }}
										value={initialForecast?.toLocaleString('en-US')}
										onChange={handleForecast}
										size="small"
										fullWidth
									></TextField>
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<TextField
										variant="outlined"
										readOnly={true}
										label="Forecast Type"
										value={forecastType}
										//select={countries.length > 0 ? true : false}
										//value={countries.length > 0 ? selectedCountry.countryID : " "}
										onChange={handleForecastType}
										fullWidth
										size="small"
										//disabled={countries.length > 0 ? false : true}
									>
										{/* {countries.length > 0 ? (
                                countries.map((country, index) => {
                                    return (
                                        <MenuItem key={country.countryID} value={country.countryID}>
                                            {country.countryName}
                                        </MenuItem>
                                    )
                                })) : null
                            } */}
									</TextField>
								</Grid>
							
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<TextField
										variant="outlined"
										label="Initial Quota"
										value={selectedQuota?.quotaCopy?.toLocaleString('en-US')}
										onChange={handleQuotaCopy}
										size="small"
										fullWidth
									></TextField>
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
										<TextField
											variant="outlined"
											label="Revised Quota"
											InputProps={{
												readOnly: true,
												style: {
												  fontStyle: 'italic',
												},
											  }}
											value={revisedQuota?.toLocaleString('en-US')}
											size="small"
											fullWidth
										></TextField>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
										<TextField
											variant="outlined"
											label="Unused Quota"
											readOnly={true}
											value={TotalUnusedQuota?.toLocaleString('en-US')}
											size="small"
											fullWidth
										></TextField>
									</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<TextField
										sx={{
											display:
												selectedScenario.periodType === "Weekly"
													? "none"
													: selectedScenario.periodType === "Monthly"
														? "block"
														: "none",
										}}
										variant="outlined"
										label="Period Structure"
										select={
											depletionPeriodTypesList.length > 0 ? true : false
										}
										value={
											depletionPeriodTypesList.length > 0 &&
											selectedDepletionPeriodType
												? selectedDepletionPeriodType.depletionPeriodTypeID
												: ""
										}
										onChange={handleDepletionPeriodTypeChange}
										size="small"
										fullWidth
										disabled={
											depletionPeriodTypesList.length > 0 ? false : true
										}
										SelectProps={{
											renderValue: (selectedId) => {
												const item = depletionPeriodTypesList.find(
													(x) =>
														x.depletionPeriodTypeID === selectedId
												);
												return item?.depletionPeriodType ?? "";
											},
										}}
									>
										{depletionPeriodTypesList.length > 0
											? depletionPeriodTypesList.map((item) => {
													const id = item.depletionPeriodTypeID;
													return (
														<MenuItem
															key={id}
															value={id}
															sx={{ py: 1.25 }}
														>
															<Tooltip
																title={
																	item.depletionPeriodTypeName || ""
																}
																placement="right"
																arrow
																disableHoverListener={
																	!item.depletionPeriodTypeName
																}
															>
																<Typography
																	variant="body2"
																	component="span"
																	sx={{ display: "block", width: "100%" }}
																>
																	{item.depletionPeriodType}
																</Typography>
															</Tooltip>
														</MenuItem>
													);
											  })
											: null}
									</TextField>
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<TextField
										sx={{
											display:
												selectedScenario.periodType === "Weekly"
													? "none"
													: selectedScenario.periodType === "Monthly"
														? "block"
														: "none",
										}}
										variant="outlined"
										label="Time Depletion"
										select={depletionModelsList.length > 0 ? true : false}
										value={
											depletionModelsList.length > 0
												? selectedDepletion?.value ?? ""
												: ""
										}
										onChange={handleTimeDepletion}
										size="small"
										fullWidth
										disabled={depletionModelsList.length > 0 ? false : true}
									>
										{depletionModelsList.length > 0
											? depletionModelsList.map((item) => {
													return (
														<MenuItem
															key={item.depletionModelID}
															value={item.depletionModelName}
														>
															{item.depletionModelName}
														</MenuItem>
													);
											  })
											: null}
									</TextField>
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
										flexWrap="nowrap"
										gap={1}
									>
										{selectedScenario?.periodType !== "Weekly" ? (
											<FormControlLabel
												sx={{
													flex: "1 1 auto",
													minWidth: 0,
													mr: 1,
													alignItems: "flex-start",
													"& .MuiFormControlLabel-label": {
														whiteSpace: "normal",
														wordBreak: "break-word",
														lineHeight: 1.3,
													},
												}}
												control={
													<Checkbox
														size="small"
														checked={Boolean(persistDepletionTypeOnAllocate)}
														onChange={(e) =>
															dispatch(
																setState(
																	"persistDepletionTypeOnAllocate",
																	e.target.checked
																)
															)
														}
														disabled={!isRestrictedAccess}
														sx={{ pt: 0.25 }}
													/>
												}
												label="Persist depletion type"
											/>
										) : (
											<Box sx={{ flex: 1, minWidth: 0 }} />
										)}
										<Button
											sx={{
												flexShrink: 0,
												bgcolor: "darkred.light",
												color: "white.main",
												fontWeight: "700",
												textTransform: "none",
												"&:hover": {
													bgcolor: "darkred.main",
												},
											}}
											variant="contained"
											size="large"
											disabled={!isRestrictedAccess}
											onClick={handleAllocate}
										>
											Allocate
										</Button>
									</Box>
								</Grid>
								<Grid
									container
									columns={12}
									justifyContent="space-between"
									alignItems="center"
									spacing={2}
									pb={2}
								>
									<Grid item xs={12} sm={12} md={12} lg={12}>
										<TextField
											variant="outlined"
											label="Select Product"
											select={listProduct.length > 0 ? true : false}
											value={
												listProduct.length > 0
													? selectedProduct.packGroupOrSKUID
													: 0
											}
											onChange={handleSelectProduct}
											size="small"
											fullWidth
											disabled={listProduct.length > 0 ? false : true}
										>
											{listProduct.length > 0
												? listProduct.map((item, index) => {
														return (
															<MenuItem
																key={item.packGroupOrSKUID}
																value={item.packGroupOrSKUID}
															>
																{item.packGroupOrSKUName}
															</MenuItem>
														);
												  })
												: null}
										</TextField>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12}>
										<Box
											sx={{
												display: "flex",
												justifyContent: "align-start",
												alignItems: "center",
											}}
										>
											<TextField
												variant="outlined"
												label="Safety Margin"
												value={commonSafetyMargin?.toLocaleString('en-US')}
												onChange={handleSafetyMargin}
												size="small"
												fullWidth
												sx={{ mr: 2 }}
											></TextField>
											<Box justifyContent="center" display="flex">
												<Button
													sx={{
														bgcolor: "darkred.light",
														color: "white.main",
														fontWeight: "700",
														textTransform: "none",
														"&:hover": {
															bgcolor: "darkred.main",
														},
														minWidth: "56px !important", // Reduced minWidth
														padding: "2px 8px",
														height: "42px !important",
													}}
													variant="contained"
													disabled={!isRestrictedAccess}
													onClick={applySafetyMargin}
												>
													Apply
												</Button>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12}>
										<TextField
											variant="outlined"
											label="Rounder"
											select
											value={selectedRounderTypeID}
											onChange={(e) =>
												dispatch(
													setSelectedRounderTypeID(
														Number(e.target.value)
													)
												)
											}
											size="small"
											fullWidth
										>
											{rounderTypesList.map((option) => (
												<MenuItem
													key={option.rounderTypeID}
													value={option.rounderTypeID}
												>
													{option.rounderType}
												</MenuItem>
											))}
										</TextField>
									</Grid>
									{!isOverBoxRounderTypeSelected(
										rounderTypesList,
										selectedRounderTypeID
									) && (
									<Grid item xs={12} sm={12} md={12} lg={12}>
										<Box
											sx={{
												display: "flex",
												justifyContent: "align-start",
												alignItems: "center",
											}}
										>
											<TextField
												variant="outlined"
												label="Round Value"
												value={
													Number.isNaN(rounder)
														? ""
														: rounder?.toLocaleString("en-US")
												}
												onChange={handleRounder}
												size="small"
												fullWidth
												sx={{ mr: 2 }}
											></TextField>
											<Box justifyContent="center" display="flex">
												<Button
													sx={{
														bgcolor: "darkred.light",
														color: "white.main",
														fontWeight: "700",
														textTransform: "none",
														"&:hover": {
															bgcolor: "darkred.main",
														},
														minWidth: "56px !important", // Reduced minWidth
														padding: "2px 8px",
														height: "42px !important",
													}}
													variant="contained"
													disabled={!isRestrictedAccess}
													onClick={applyRounder}
												>
													Apply
												</Button>
											</Box>
										</Box>
									</Grid>
									)}
									{isOverBoxRounderTypeSelected(
										rounderTypesList,
										selectedRounderTypeID
									) && (
									<Grid item xs={12} sm={12} md={12} lg={12}>
										<Box display="flex" justifyContent="flex-end">
											<Button
												sx={{
													bgcolor: "darkred.light",
													color: "white.main",
													fontWeight: "700",
													textTransform: "none",
													"&:hover": {
														bgcolor: "darkred.main",
													},
													height: "42px !important",
												}}
												variant="contained"
												disabled={!isRestrictedAccess}
												onClick={() => setOverBoxDialogOpen(true)}
											>
												Fill OverBox Round Value
											</Button>
										</Box>
									</Grid>
									)}
									{/* <Grid item xs={12} sm={12} md={12} lg={12}>
										<Box
											sx={{
												display: "flex",
												justifyContent: "align-start",
												alignItems: "center",
											}}
										>
											<TextField
												variant="outlined"
												label="Buffer Adjustment"
												value={bufferAdjustment?.toLocaleString()}
												onChange={handleBufferAdjustment}
												size="small"
												fullWidth
												sx={{ mr: 2 }}
											></TextField>
											<Box justifyContent="center" display="flex">
												<Button
													sx={{
														bgcolor: "darkred.light",
														color: "white.main",
														fontWeight: "700",
														textTransform: "none",
														"&:hover": {
															bgcolor: "darkred.main",
														},
														minWidth: "56px !important", // Reduced minWidth
														padding: "2px 8px",
														height: "42px !important",
													}}
													variant="contained"
													disabled={!isRestrictedAccess}
													onClick={applyBufferAdjustment}
												>
													Apply
												</Button>
											</Box>
										</Box>
									</Grid> */}
								
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={9.25}
								lg={9.25}
								sx={{
									ml: 2,
									borderLeft: 1,
									borderColor: "#c6c6c6",
									paddingTop: "0px !important",
								}}
							>
								<Box
									display="flex"
									flexDirection={{ xs: "column", sm: "row" }}
									justifyContent="space-between"
									alignItems="center"
									sx={{ p: 0 }}
								>
									<Box display="flex" flexDirection="column" width="100%">

											<Box className="quota_details_layout" sx={{ width: "100%", mb: 2 }}>
												<Box sx={{ display: "flex", justifyContent: "space-evenly", flexWrap: "wrap" }}>
												<Typography className="quota_numbers">
													{ForecastAdjustment?.toLocaleString('en-US')}
													<Typography className="quota_labels">Forecast Adjustment</Typography>
												</Typography>

												<Typography className="quota_numbers">
													{TotalAdjustment?.toLocaleString('en-US')}
													<Typography className="quota_labels">Customers Adjustment</Typography>
												</Typography>

												<Typography className="quota_numbers">
													{TotalTender?.toLocaleString('en-US')}
													<Typography className="quota_labels">Tender</Typography>
												</Typography>

												<Typography className="quota_numbers">
													{TotalSafetyMargin?.toLocaleString('en-US')}
													<Typography className="quota_labels">Safety Margin</Typography>
												</Typography>

												{/* <Typography className="quota_numbers">
													{TotalUnusedQuota?.toLocaleString()}
													<Typography className="quota_labels">Total Unused Quota</Typography>
												</Typography> */}
												      <Box
														sx={{
															height: "50px",
															width: "2px",
															backgroundColor: "#1976d2", // Blue shade
															margin: "0 16px",
															
														}}
														/>

												<Typography className="quota_numbers">
													{TotalQuota?.toLocaleString('en-US')}
													<Typography className="quota_labels">Total Quota</Typography>
												</Typography>

											
												</Box>
											</Box>

											{loadQuotaChart && (
												<Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
												<ChartTableToggle />
												</Box>
											)}
											</Box>


								</Box>
								{loadQuotaChart && <DefineQuotaChart />}
								{loadQuotaChart && <DefineQuotaTable />}
							</Grid>
						</Grid>
					</CollapseSection>
				</>
			)}
			{loadQuotaDetails && (
				<>
					{/* <Stack direction="row" alignItems="center" gap={2}>
                     <Typography
                        className="compHeading"
                        sx={{
                           color: "#007DC3",
                           fontWeight: "bold",
                           mt: 3,
                           width: "100%",
                        }}
                     >
                        <DownloadOutlined
                           sx={{ mt: 0, transform: "translate(0px, 8px)" }}
                           color="info"
                        />{" "}
                        Customer Breakdown
                     </Typography>
                  </Stack> */}
					<CollapseSection sx={{ mt: 2 }} title="Customer Breakdown">
						<Box sx={!loadQuotaDetails && { display: "none" }}>
							<ViewSearchRefresh />
							<DefineQuotaBreakdown />
						</Box>
					</CollapseSection>
				</>
			)}

			{loadQuotaDetails && (
				<>
					{/* {selectedQuota?.listQuotaFiles?.length > 0 && (
                     <Stack direction="row" alignItems="center" gap={2}>
                        <SpeakerNotesOutlined color="darkred.light" sx={{ mt: 4 }} />
                        <Typography
                           sx={{ color: "darkred.light", fontWeight: "bold", mt: 4 }}
                        >
                           Attachments
                        </Typography>
                     </Stack>
                  )} */}
					<CollapseSection sx={{ mt: 2 }} title="Attachments">
						<Table>
							<TableBody>
								{selectedQuota?.listQuotaFiles.map((row) => {
									return (
										<TableRow className="tableRow" key={row?._id} width={"90%"}>
											<TableCell className="tableCell" sx={{ flexGrow: 1 }}>
												{row.filePath}
											</TableCell>
											<TableCell className="tableCell" width={"5%"}>
												<IconButton
													edge="start"
													aria-label="download"
													onClick={() => handleDownloadFile(row.filePath)}
												>
													<DownloadRoundedIcon />
												</IconButton>
											</TableCell>
											<TableCell className="tableCell" width={"5%"}>
												<IconButton
													edge="end"
													aria-label="delete"
													onClick={() => handleDeleteFile(row)}
													sx={{ mr: 2 }}
												>
													<DeleteIcon />
												</IconButton>
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
						<FileAttach />
						<Attachments />
					</CollapseSection>
					<CollapseSection sx={{ mt: 2 }} title="Comments">
						<Comments />
					</CollapseSection>
					<Grid container columns={12} justifyContent="flex-start" my={4}>
						<Grid item xs={6} sm={2} md={2} lg={1.5}>
							<Button
								sx={{
									bgcolor: "darkred.light",
									color: "white.main",
									fontWeight: "700",
									textTransform: "none",
									"&:hover": {
										bgcolor: "darkred.main",
									},
									ml: 1,
								}}
								variant="contained"
								disabled={!isRestrictedAccess}
								startIcon={<UploadOutlined />}
								onClick={handleUploadQuota}
							>
								Upload Quota
							</Button>
						</Grid>
						<Grid item xs={6} sm={2} md={2} lg={1.6}>
							<Button
								sx={{
									bgcolor: "darkred.light",
									color: "white.main",
									fontWeight: "700",
									textTransform: "none",
									"&:hover": {
										bgcolor: "darkred.main",
									},
								}}
								variant="contained"
								startIcon={<DownloadOutlined />}
								onClick={handleDownloadQuota}
							>
								Download Quota
							</Button>
						</Grid>
					</Grid>
					<Box my={2} />
					<Grid
						container
						columns={12}
						spacing={1}
						justifyContent="flex-end"
						alignItems="right"
						my={2}
					>
						<Grid item xs={6} sm={2} md={2} lg={1.3}>
							<Button
								sx={{
									bgcolor: "grey.lighter",
									color: "darkred.light",
									boxShadow: "none",
									"&:hover": {
										bgcolor: "darkred.main",
										color: "white.main",
										border: "none",
									},
								}}
								variant="contained"
								startIcon={<SaveOutlined />}
								onClick={handleSaveQuota}
								disabled={onSubmitDisabled || !isRestrictedAccess}
							>
								Save Quota
							</Button>
						</Grid>
						<Grid item xs={6} sm={2} md={2} lg={1.5}>
							<Button
								sx={{
									bgcolor: "darkred.light",
									color: "white.main",
									fontWeight: "700",
									textTransform: "none",
									"&:hover": {
										bgcolor: "darkred.main",
									},
								}}
								variant="contained"
								startIcon={<TaskAltOutlined />}
								onClick={handleSubmitQuota}
								disabled={onSubmitDisabled || !isRestrictedAccess}
							>
								Submit Quota
							</Button>
						</Grid>
					</Grid>
					<Box my={2} />
				</>
			)}

			<Backdrop
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.modal + 1,
				}}
				open={isLoading}
			>
				<CircularProgress />
			</Backdrop>
			<SharedComponent />
			<Dialog
				open={open}
				onClose={handleClose}
				PaperComponent={PaperComponent}
				aria-labelledby="draggable-dialog-title"
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle style={{ cursor: "move" }}>
					<Typography
						sx={{
							color: "darkred.light",
							fontWeight: "700",
							fontSize: "18px !important",
						}}
					>
						Upload Quota{" "}
					</Typography>
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: "darkred.light",
						}}
					>
						<Close />
					</IconButton>
				</DialogTitle>
				<DialogContent
					sx={{
						paddingTop: "5px !important",
						paddingBottom: "12px !important",
					}}
				>
					<div className="dropzone-container">
						<Dropzone
							onDrop={onDrop}
							multiple={false}
							// accept = {["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
						>
							{({ getRootProps, getInputProps }) => (
								<section className="dropzone">
									<div {...getRootProps({})}>
										<input {...getInputProps()} />
										{selectedFiles && selectedFiles[0].name ? (
											<div className="selected-file">
												{selectedFiles && selectedFiles[0].name}
											</div>
										) : (
											<div>
												<UploadFile fontSize="medium" />
												<div>Drag file here or click to browse</div>
											</div>
										)}
									</div>
								</section>
							)}
						</Dropzone>
					</div>
				</DialogContent>
				<DialogActions sx={{ padding: "12px 24px !important" }}>
					<Button
						onClick={handleClose}
						sx={{
							my: 0.5,
							bgcolor: "grey.lighter",
							color: "darkred.light",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
								bgcolor: "darkred.main",
								color: "white.main",
								border: "none",
							},
						}}
					>
						Cancel
					</Button>
					<Button
						sx={{
							bgcolor: "darkred.light",
							color: "white.main",
							fontWeight: "700",
							textTransform: "none",
							"&:hover": {
								bgcolor: "darkred.main",
							},
						}}
						variant="contained"
						onClick={handleProcess}
						type="submit"
					>
						Process
					</Button>
				</DialogActions>
			</Dialog>
			<OverBoxRounderDialog
				open={overBoxDialogOpen}
				onClose={() => setOverBoxDialogOpen(false)}
				onApply={applyOverBoxRounder}
				disabled={!isRestrictedAccess}
			/>
		</Box>
		/* </form> */
	);
}

export default DefineQuota;
